import { useState, createContext, useContext, ReactNode } from 'react';

interface SidebarContextShape {
  expanded: boolean;
  setExpanded: (v: boolean) => void;
}

export const SidebarContext = createContext<SidebarContextShape | undefined>(undefined);

export const SidebarProvider = ({ children }: { children: ReactNode }) => {
  const [expanded, setExpanded] = useState(false);
  return <SidebarContext.Provider value={{ expanded, setExpanded }}>{children}</SidebarContext.Provider>;
};

export const useSidebar = () => {
  const ctx = useContext(SidebarContext);
  if (!ctx) throw new Error('useSidebar must be used within SidebarProvider');
  return ctx;
};
